module.exports = __webpack_public_path__ + "files/Bulletin établissements 7-10.3657bf04741bf3b8501d821588b80923.pdf";